module.exports = __webpack_public_path__ + "src/assets/games/12/135.jpg";